import { AIEditingDTO } from 'models/purchaseFlow'
import { AxiosResponse } from 'axios'
import { PropertyVisualUploadEndpoints } from 'constants/API'
import { getMutation } from 'utils/reactQuery'
import { useAPI } from 'utils/API'

interface SelfUploadPayload {
  workspaceId: string,
  realtyId: string
  sessionId: string,
  aiEditingRequest?: AIEditingDTO
}

export function useSelfUpload() {
  const api = useAPI<PropertyVisualUploadEndpoints>()

  return getMutation<AxiosResponse<{ id: string }>, SelfUploadPayload>(
    ({ workspaceId, realtyId, sessionId, aiEditingRequest }) => api.post(
      PropertyVisualUploadEndpoints.POST_SELF_UPLOAD_VISUALS,
      {
        workspaceId,
        realtyId
      },
      {
        sessionId,
        aiEditingRequest
      },
      true,
      {}
    )
  )
}
